import FormsActions from "@/components/forms/FormsActions";
import Season from "@/server/com/silkplm/model/plm/Season";
import SubSeason from "@/server/com/silkplm/model/plm/SubSeason";
import Product from "@/server/com/silkplm/model/plm/Product";
import FormsLoader from "@/components/forms/FormsLoader";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ActivityManager from "@/activity/ActivityManager";

export default async function assignProducts() {
    await ActivityManager.closeAll();

    let season = await (await FormsActions.showSelectList(Season, {
        showAdd: false, showDelete: false, showExport: false,
        formTitle: $tr('productToSeason.season','Assign Products to Season: Seasons')
    })).getResult();
    if (!season) {
        return;
    }
    let allSubSeasons = await Rpc.plm.services.ProductService.findAllSubSeasons();
    let excludedSubSeasonsId = [];
    for (let sub of allSubSeasons) {
        if (sub.seasonId !== season.id) {
            excludedSubSeasonsId.push(sub.id);
        }
    }
    let subSeason = await (await FormsActions.showSelectList(SubSeason, {
        showAdd: false,
        showDelete: false,
        showExport: false,
        formTitle: $tr('productToSeason.subSeason','Assign Products to Season: Sub-seasons')
    }, excludedSubSeasonsId)).getResult();
    if (!subSeason) {
        return;
    }
    setTimeout(async () => {
        let excludedProductId = await Rpc.plm.services.ProductService.findRawProductsInSeason(season.id);
        let products = await (await FormsActions.showMultiSelectList(Product, {
            showAdd: false,
            showDelete: false,
            formTitle: $tr('productToSeason.season.product','Assign Products to Season: Products'),
            showImport: false,
            showExport: false
        }, excludedProductId)).getResult();
        if(products?.materialize){
            await products.materialize();
        }

        if (products && products.length) {
            let productsIds = products.map(product => product.id);
            await Rpc.plm.services.ProductService.addMultiProductsToSeasonAndSubSeason(productsIds, season.id, subSeason.id).lock();
            let subSeasonForm = FormsLoader.detectFormConfig(subSeason);
            let result = await FormsActions.showList(ProductInSeason, {
                    filter: {
                        filterSpecs: [
                            {
                                fieldName: "subSeasonId",
                                fieldLabel: "season",
                                filterSpec: {
                                    idValues: [subSeason.id],
                                    mergeTree: false,
                                }
                            }
                        ],
                    },
                    showAdd: false,
                }
            );
            result.suffix = " - " + subSeason.code;
            // [{"fieldName":"category","fieldLabel":"Category","filterSpec":{"idValues":[".4.PmiU.Aqbr_DMsOaxiWa5slMB-vw"],"mergeTree":true}}]
            // fieldName: this.form.clusterByField,
            //     clusterId: res.id

        }
    })
}


